import { useLoaderData } from '@remix-run/react';
import type { loader } from './loaders/articles-page-loader.server';
import { mapESArticleComponentProps } from '@modules/professional/util/company-article-helper';
import PaginatedJournalArticles from '@modules/professional/component/article-tab/PaginatedJournalArticles';
import { useIsDisabledInPreview } from '@modules/root/hook/use-is-disabled-in-preview';

const ArticlesPage = () => {
    const companyArticlesResult = useLoaderData<typeof loader>();
    const disableTileLink = useIsDisabledInPreview('featured_tile_links');
    const disableSaveToDesignBoard =
        useIsDisabledInPreview('save_design_board');
    const disableSort = useIsDisabledInPreview('directory_sort');

    return (
        <PaginatedJournalArticles
            {...mapESArticleComponentProps(companyArticlesResult)}
            filterStates={companyArticlesResult.filterStates}
            disableTileLink={disableTileLink}
            disableSaveToDesignBoard={disableSaveToDesignBoard}
            disableSort={disableSort}
        />
    );
};

export default ArticlesPage;
